export default __webpack_public_path__ + "static/corporate_individual_mini-f7aa6af0bf1b18d2a751b2858b7aab0c.png";